import React , {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import TextInput from '../../../../Shared/TextInput/TextInput';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import { prepareNewWindowUrl } from '../../../../../utilities/StringHelpers/StringHelpers.js';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';

const UpdateEmail = (props) => {
  const [primaryEmail, setNewEmail] = useState(props.primaryEmail || '');
  const [showUpdateEmailInput, setShowUpdateEmailInput] = useState(false);
  const [isPhoneDelivery, setIsPhoneDelivery] = useState(false);

  const showUpdateEmailInputFunc = () => {
    setShowUpdateEmailInput(true);
  };
    const onRadioBtnChange = (e) => {
        let value = e.currentTarget.value;
        props.setSelectedInvoicingDeliveryType(value)
    }

    const navigateToPolicy = async (link) => {
        prepareNewWindowUrl(link, props.context);
    };

    const ResetEmail = () => {
      setNewEmail(props.primaryEmail);
    };


    useEffect(() => {
      if (props.primaryEmail !== null && props.primaryEmail !== "") {
        props.setInvoicingDeliveryDetails('email', props.primaryEmail);
        props.setSelectedInvoicingDeliveryType('email');
        setIsPhoneDelivery(false);
      }
    }, []);

    const handleDeliveryTypeChange = (value,e) => {
      if (value === 'email') {
        const newEmail = e.target.value;
        setNewEmail(newEmail);
        props.setInvoicingDeliveryDetails('email', newEmail);
        props.setSelectedInvoicingDeliveryType('email');
        setIsPhoneDelivery(false);
      } else if (value === 'onCheckPhone') {
        setIsPhoneDelivery(!isPhoneDelivery);
        if (!isPhoneDelivery) {
          ResetEmail();
        }
        props.setSelectedInvoicingDeliveryType('phone');
      }
      else if(value === 'onUncheckPhone'){
        setNewEmail(props.primaryEmail);
        props.setInvoicingDeliveryDetails('email', props.primaryEmail);
        props.setSelectedInvoicingDeliveryType('email');
        setIsPhoneDelivery(false);
      }
    };


    return (
        <>
            <div className='update-email-container'>
                {props.movingWithTechnician ? (
                    <>
                    {props.primaryEmail && !showUpdateEmailInput ? (
                          <div className='current-email-wrapper'>
                            <div className='email-title'>
                              סיכום ההזמנה יישלח לכתובת מייל ראשית לדיוור ומידע <span style={{ fontWeight: 'bold' }}>{props.primaryEmail}</span>
                            </div>
                            { props.emailError && <div className='email-error'>{props.emailError}</div> }
                            <button className='open-email-input-btn' onClick={showUpdateEmailInputFunc}>
                              עדכון מייל
                            </button>
                            </div>
                          ) : (
                            <>

                            {(showUpdateEmailInput || !props.primaryEmail) && (
                              <>
                               <div className='update-email-title'>
                                לאיזה מייל לשלוח את סיכום ההזמנה?
                              </div>
                              <div className='update-email-input'>
                                <div className='update-email-subTitle'>{Config.receivingAdTitle}</div>
                                <TextInput
                                  value={primaryEmail}
                                  onChange={(e) => handleDeliveryTypeChange('email',e)}
                                  type='email'
                                  required='required'
                                  placeholder='מייל'
                                  error={props.email.error}
                                  id='email'
                                  disabled={isPhoneDelivery}
                                />
                                <div className='text-under-input'>
                                  {Config.primaryEmailText}{' '}
                                  <a href="#" className='link' onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)} target="_blank">
                                    {Config.primaryEmailMoreInfoText}
                                  </a>{' '}
                                </div>
                              </div>
                               <div className='phone-checkbox-container'>
                                <div className='phone-checkbox'>
                                <CheckBox
                                  id={"phone"}
                                  name={'invoiceDeliveryType'}
                                  onCheck={(e) => handleDeliveryTypeChange('onCheckPhone',e)}
                                  onUncheck={(e) => handleDeliveryTypeChange('onUncheckPhone',e)}
                                  label={`תשלחו לי את הסיכום לנייד ${props.phoneNumber}`}
                                />
                                </div>
                                <div className='divider'></div>
                             </div>
                             </>
                            )}
                          </>
                        )}
                      </>
                ) : (
                    <>
                        <div className='update-email-title'>שנעדכן גם את כתובת המייל?</div>
                        <div className='update-email-input'>
                          <div className='update-email-subTitle'>{Config.receivingAdTitle}</div>
                            <TextInput
                                value={primaryEmail}
                                onChange={(e) => handleDeliveryTypeChange('email',e)}
                                type='email'
                                required='required'
                                placeholder='מייל'
                                error={props.email.error}
                            />
                            <div className='text-under-input'> {Config.primaryEmailText} <a href="#" onClick={() => buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl)} className='link'> {Config.primaryEmailMoreInfoText}</a> </div>
                          </div>
                    </>
                )
                }

            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
        invoicingDeliveryType: state.movingBlock.movingApartmentData.invoicingDeliveryType,
        isCheckedUpdateDeliveryAddress: state.movingBlock.movingApartmentData.isCheckedUpdateDeliveryAddress,
        emailError: state.movingBlock.movingApartmentData.email?.error,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEmail);
